import { useFinalTechMapTable } from './useFinalTechMapTable';
import { useFinalTechMapTableEffect } from './useFinalTechMapTableEffect';

export { useFinalTechMapTableEffect, useFinalTechMapTable };
